/**
 * @desc 入库单明细搜索
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inDetail.indetailSearch.Params, options?: any) {
  return updateResponse(
    http(URL + `/inDetail/indetailSearch`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
